import { render, staticRenderFns } from "./ReplaceProductItem.vue?vue&type=template&id=f3ee5ff6"
import script from "./ReplaceProductItem.vue?vue&type=script&lang=js"
export * from "./ReplaceProductItem.vue?vue&type=script&lang=js"
import style0 from "./ReplaceProductItem.vue?vue&type=style&index=0&id=f3ee5ff6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports